import React from 'react';
import classNames from 'classnames';
import Styles from './table-header-row.less';

const baseClass = Styles.tr;

module.exports = React.createClass({
  displayName: 'TableHeaderRow',
  propTypes: {
    className: React.PropTypes.string
  },
  getChildren() {
    return React.Children.toArray(this.props.children)
      .filter(React.isValidElement)
      .filter(child => child.type.displayName == 'TableHeaderColumn');
  },
  getClass() {
    return classNames(baseClass, this.props.className);
  },
  render: require('./table-header-row.rt')
});




/** WEBPACK FOOTER **
 ** ./src/table/table-header-row/table-header-row.js
 **/